/* eslint-disable */
import {
    get_utenti_azienda,
    create_utente_admin,
    update_utente_admin,
    reset_password_utente,
    abilita_utente,
    disabilita_utente,
    impersona_utente,
} from "@/api/api.superadmin-utenti.js";

const utentiAdmin = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => { state.lista = lista; },
    },

    actions: {
        carica({ commit }, aziendaId) {
            return new Promise((resolve, reject) => {
                get_utenti_azienda(aziendaId).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati, aziendaId }) {
            const call = id ? update_utente_admin(id, dati) : create_utente_admin(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica", aziendaId);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        resetPassword({ }, { id, nuovaPassword }) {
            return reset_password_utente(id, nuovaPassword);
        },

        abilita({ dispatch }, { id, aziendaId }) {
            return new Promise((resolve, reject) => {
                abilita_utente(id).then(resp => {
                    dispatch("carica", aziendaId);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        disabilita({ dispatch }, { id, aziendaId }) {
            return new Promise((resolve, reject) => {
                disabilita_utente(id).then(resp => {
                    dispatch("carica", aziendaId);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        // NOTA: non tocca lo storage/token: restituisce solo la risposta API.
        // Chi la usa deve poi chiamare "auth/avviaImpersonificazione" con resp.data.
        impersona({ }, { id, motivo }) {
            return impersona_utente(id, motivo);
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default utentiAdmin;